// import axios from "axios";

// const api = axios.create({
//   baseURL: "https://didamax.net/api",
//   headers: {
//     "Content-Type": "application/json",
//   },
//   params: {
//     api_password: "EcommercApp@2026_$",
//   },
  
// });

// export default api;

import axios from "axios";

const api = axios.create({
  baseURL: "https://didamax.net/api",
  headers: {
    Accept: "application/json",
  },
  params: {
    api_password: "EcommercApp@2026_$",
  },
});

export default api;
